import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import {
    EditProfile,
    GetUserDetailsByAdmin,
    EditUserByAdmin,
    ProfileActionTypes,
    ProfileErrorAcion,
} from '../store/profile.actions'
import { ActivatedRoute } from '@angular/router';
import { API } from '../../../../services/Api.service'
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ChangeEmailComponent } from '../change-email/change-email.component';
import { MatDialog } from '@angular/material';
import { FileTypeValidator } from 'src/app/directives/image-validation';
import { ChangePhoneComponent } from '../change-phone/change-phone.component';
import { Location } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { GetConfigurations } from '../../configurations/store/configurations.actions';
import { ProfilePictureService } from '../../../../services/profilePicture.service';
import { Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { LoaderHide, LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { GetUserDetails } from 'src/app/login/store/auth.actions';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../utils/validation.util";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './profile-edit.component.html',
    styleUrls: ['./profile-edit.component.scss']
})
export class ProfileManagmentComponent implements OnInit {
    profileForm: FormGroup;
    changeEmailForm: FormGroup;
    userID: string = '';
    profileDetails$: any;
    profilePic$: any;
    showChangeEmailForm: boolean = false;
    imageURL: any;
    userProfileImage;
    file;
    countryCodes;
    profilePicName = '';
    profilePicID = '';
    userIdParam: string;
    formData: FormData = new FormData();
    aboutMeField: any = {
        'displayName': '',
        'value': 0
    };
    validationMsg = VALIDATION_MESSAGES;
    isProfileImageInvalid: boolean = false;
    versionList:Array<any>=[];
    version:any=[];
    selectedVersionList:any=[];
    selectedV1VersionList:any=[];
    selectedV2VersionList:any=[];

    citiisV1CheckValue:boolean=false;
    citiisV2CheckValue:boolean=false;
    isVersionArray: FormArray;
    constructor(
        private store: Store<AppState>,
        private api: API,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        public location: Location,
        public profile: ProfilePictureService,
        private action$: Actions,
        private notificationService: NotificationsService
    ) { 
        this.profileForm = this.fb.group({
            email: ['', Validators.required],
            firstName: ['', Validators.compose([
                Validators.required,
                ValidationUtil.cannotBeBlank,
            ])],
            middleName: [''],
            lastName: ['', Validators.compose([
                Validators.required,
                ValidationUtil.cannotBeBlank,
            ])],
            countryCode: ['', Validators.required],
            phone: ['', [Validators.required]],
            aboutme: ['', Validators.maxLength(200)],
            role: [''],
            upfile: ['', [FileTypeValidator.validate]],
            // version: this.fb.array([]),

        });
    }

    ngOnInit() {
        this.route.params.subscribe(param => {
            this.userIdParam = param.id
        });

        this.versionList=[{name:"CITIIS 1.0",value:"CITIIS 1.0",checked:false},{name:"CITIIS 2.0",value:"CITIIS 2.0",checked:false}];
        // this.isVersionArray = this.profileForm.get("version") as FormArray;
        console.log(this.isVersionArray);
        this.changeEmailForm = this.fb.group({
            email: ["", Validators.required],
            password: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.pattern(
                        "(?=.*?[#?!@$%^&*-]).{6,}"
                    )
                ])
            ]
        });

        if (this.userIdParam) {
            this.store.dispatch(new GetUserDetailsByAdmin(this.userIdParam))
            this.store.select(store => store.profile.userDetail).subscribe(
                res => {
                    if (Object.keys(res).length) {
                        this.userProfileImage = `${environment.host}/user/getImage/${this.userIdParam}`
                        this.file = this.userProfileImage;
                        const roleString = ((res['role'] && res['role'].length) ? res['role'] : []).reduce((acc, rol, index) => {
                            if (index < res['role'].length - 1) {
                                return acc.concat(rol, ', ');
                            } else {
                                return acc.concat(rol);
                            }
                        }, '');
                        this.profileForm = this.fb.group({
                            email: [res['email'], Validators.required],
                            firstName: [res['firstName'], Validators.compose([
                                Validators.required,
                                ValidationUtil.cannotBeBlank,
                            ])],
                            middleName: [res['middleName'] || ''],
                            lastName: [res['lastName'], Validators.compose([
                                Validators.required,
                                ValidationUtil.cannotBeBlank,
                            ])],
                            countryCode: [res['countryCode'], Validators.required],
                            phone: [res['phone'], Validators.required],
                            aboutme: [res['aboutme'] || ''],
                            role: [roleString],
                            // version:[res['version'] ],
                            upfile: '',
                        });
                        this.profilePicID = res['profilePic'];
                        // this.version= res['version'];
                        this.citiisV1CheckValue=res['cities_1_flag'];
                        this.citiisV2CheckValue=res['cities_2_flag'];
                        if(res['cities_1_flag']){
                            this.selectedV1VersionList.push({'checked':res['cities_1_flag'],'value':'CITIIS 1.0'});
                        }
                        if(res['cities_2_flag']){
                            this.selectedV2VersionList.push({'checked':res['cities_2_flag'],'value':'CITIIS 2.0'}); 
                        }
                    
                    }
                }
            )
        } else {
            this.store.dispatch(new GetUserDetails());
            this.profileDetails$ = this.store.select(state => state.auth.user).pipe()
                .subscribe(profile => {
                    this.userID = (profile['details'] || {})._id;
                    this.userProfileImage = `${environment.host}/user/getImage/${this.userID}`
                    this.file = this.userProfileImage;
                    console.log(profile['role']);
                    const roleString = ((profile['role'] && profile['role'].length) ? profile['role'] : []).reduce((acc, rol, index) => {
                        if (index < profile['role'].length - 1) {
                            return acc.concat(rol, ', ');
                        } else {
                            return acc.concat(rol);
                        }
                    }, '');
                    this.profileForm = this.fb.group({
                        email: [profile['details']['email'], Validators.required],
                        firstName: [profile['details']['firstName'], Validators.compose([
                            Validators.required,
                            ValidationUtil.cannotBeBlank,
                        ])],
                        middleName: [profile['details']['middleName'] || ''],
                        lastName: [profile['details']['lastName'], Validators.compose([
                            Validators.required,
                            ValidationUtil.cannotBeBlank,
                        ])],
                        countryCode: [profile['details']['countryCode'], Validators.required],
                        phone: [profile['details']['phone'], Validators.required],
                        aboutme: [profile['details']['aboutme'] || ''],
                        role: [roleString],
                        //  version:[profile['details']['version']],
                        upfile: '',
                    });
                    this.profilePicID = profile['details']['profilePic'];
                    // this.version= profile['details']['version'];
                    this.profile.changePicture(this.file)
                    this.citiisV1CheckValue=profile['details']['cities_1_flag'];
                    this.citiisV2CheckValue=profile['details']['cities_2_flag'];
                    if(profile['details']['cities_1_flag']){
                        this.selectedV1VersionList.push({'checked':profile['details']['cities_1_flag'],'value':'CITIIS 1.0'});
                    }
                    if(profile['details']['cities_2_flag']){
                        this.selectedV2VersionList.push({'checked':profile['details']['cities_1_flag'],'value':'CITIIS 2.0'}); 
                    }

                });
        }

        this.api.getCountryCodes().subscribe(response => {
            this.countryCodes = response;
        });
        this.store.dispatch(new GetConfigurations());
        this.store.select(state => state.configurations.configurations).subscribe((resp) => {
            let index = Object.keys(resp).findIndex((key) => key === 'aboutMe');
            if (index !== -1) {
                this.aboutMeField = resp['aboutMe']
                let validators = [Validators.maxLength(parseInt(resp['aboutMe'].value))]
                this.profileForm.get('aboutme').setValidators([...validators])
            }
        });

        this.action$.pipe(
            ofType(ProfileActionTypes.PROFILE_ERROR_ACTION),
            tap((action: ProfileErrorAcion) => {
                const error = (action.error || {}).error;
                let errorMsg;
                if (error && error.errors && error.errors.length > 0) {
                    errorMsg = error.errors[0].error;
                }
                if (errorMsg && errorMsg.length > 0) {
                    this.notificationService.error(errorMsg);
                }
                this.store.dispatch(new LoaderHide())
            })
        ).subscribe();
    }

    // onVersionChange(e, val){
    //     console.log(val)
    //     //  const isVersionArray: FormArray = this.profileForm.get("version") as FormArray;
    //      console.log(this.profileForm.get("version"));
    //     console.log(this.isVersionArray);
    //     console.log(e);
    //     if (e.checked) {
    //         this.isVersionArray.push(new FormControl(val));
    //       if (!this.selectedVersionList.includes(val)) {
    //       this.selectedVersionList.push({'checked':e.checked,'value':val});
    //       }
    //     } else {
    //       let i: number = 0;
    //       console.log(val);
    //       this.isVersionArray.controls.forEach((item: FormControl) => {
    //         console.log(item);
    //         console.log(item.value);
    //         if (item.value == val) {
    //             this.isVersionArray.removeAt(i);
    //           return;
    //         }
    //         i++;
    //       });
    //      this.selectedVersionList.forEach((item: any) => {
    //         console.log(item);
    //         console.log(item.value);
    //         console.log(val);
    //         if (item.value == val) {
    //             // this.selectedVersionList.removeAt(i);
    //             console.log(item.value)
    //             this.selectedVersionList=this.selectedVersionList.filter(obj => obj.value !== val);

    //           return;
    //         }
    //         i++;
    //       });
    //     }
    //     this.version=this.isVersionArray.value;
    //     // this.profileForm.controls.version=isVersionArray;
    //     this.profileForm.value.version=this.isVersionArray.value;
    //     console.log(this.isVersionArray);
    //     console.log(this.selectedVersionList);
    //     console.log(this.version);
    //   }
    inviteBtnClick:boolean=false;
    onV1VersionChange(e, val){
        if (e.checked) {
          if (!this.selectedV1VersionList.includes(val)) {
          this.selectedV1VersionList.push({'checked':e.checked,'value':val});
          this.inviteBtnClick=false;
          }
          this.citiisV1CheckValue=true;
        } else {
          let i: number = 0;
          console.log(val);
         this.selectedV1VersionList.forEach((item: any) => {
            console.log(item);
            console.log(item.value);
            console.log(val);
            if (item.value == val) {
                // this.selectedVersionList.removeAt(i);
                console.log(item.value)
                this.selectedV1VersionList=this.selectedV1VersionList.filter(obj => obj.value !== val);

              return;
            }
            i++;
          });
          this.citiisV1CheckValue=false;
          if(this.selectedV2VersionList.length === 0){
            this.inviteBtnClick=true;
          }
          else{
            this.inviteBtnClick=false;
          }
        }
        console.log(this.selectedV1VersionList);
        console.log(this.citiisV1CheckValue);
    }
    onV2VersionChange(e, val){
        if (e.checked) {
          if (!this.selectedV2VersionList.includes(val)) {
          this.selectedV2VersionList.push({'checked':e.checked,'value':val});
          this.inviteBtnClick=false;
          }
          this.citiisV2CheckValue=true;
        } else {
          let i: number = 0;
          console.log(val);
         this.selectedV2VersionList.forEach((item: any) => {
            console.log(item);
            console.log(item.value);
            console.log(val);
            if (item.value == val) {
                // this.selectedVersionList.removeAt(i);
                console.log(item.value)
                this.selectedV2VersionList=this.selectedV2VersionList.filter(obj => obj.value !== val);

              return;
            }
            i++;
          });
          this.citiisV2CheckValue=false;
          if(this.selectedV1VersionList.length === 0){
            this.inviteBtnClick=true;
          }
          else{
            this.inviteBtnClick=false;
          }
        }
        console.log(this.selectedV2VersionList);
        console.log(this.citiisV2CheckValue);
    }
    saveProfileDetails() {
        if(this.selectedV1VersionList.length===0 && this.selectedV2VersionList.length===0){
            this.inviteBtnClick=true;
        }
        console.log(this.profileForm);
        // if(this.selectedVersionList){
        // this.profileForm.get('version').markAsDirty();
        // }
        if (this.profileForm.valid) {
            if(this.inviteBtnClick!==true){
            let V1VersionData=this.citiisV1CheckValue;
            let V2VersionData=this.citiisV2CheckValue;

            // let v1Value:boolean=false;
            // let v2Value:boolean=false;
            // this.selectedVersionList.forEach((item)=>{
            //     console.log(item);
            //     if(item.value=="CITIIS 1.0"){
            //         v1Value=true;
            //     }
            //     else if(item.value=="CITIIS 2.0"){
            //         v2Value=true;
            //     }
            //     // else{
            //     //     v1Value
            //     // }
            // })
            console.log(this)
            this.formData.set('firstName', this.profileForm.value.firstName.trim());
            this.formData.set('middleName', this.profileForm.value.middleName.trim());
            this.formData.set('lastName', this.profileForm.value.lastName.trim());
            // this.formData.set('email', this.profileForm.value.email.trim());
            this.formData.set('countryCode', this.profileForm.value.countryCode);
            // this.formData.set('phone', this.profileForm.value.phone);
            this.formData.set('aboutme', this.profileForm.value.aboutme.trim());
            this.formData.set('cities_1_flag', JSON.stringify(V1VersionData));
            this.formData.set('cities_2_flag', JSON.stringify(V2VersionData));
            // this.formData.set('version', JSON.stringify(VersionData));
            this.formData.set('upfile', this.userProfileImage);
            this.store.dispatch(new LoaderShow());

            if (this.userIdParam) {
                this.store.dispatch(new EditUserByAdmin(this.userIdParam, this.formData))
            } else {
                this.store.dispatch(new EditProfile(this.userID, this.formData));
            }
        }
        } else {
            console.log(this.profileForm.controls);
            for (let control in this.profileForm.controls) {

                this.profileForm.controls[control].markAsTouched();
                this.profileForm.controls[control].markAsDirty();

            }
            // this.profileForm.get('email').markAsDirty();
            // this.profileForm.get('firstName').markAsDirty();
            // this.profileForm.get('lastName').markAsDirty();
            // this.profileForm.get('email').markAsDirty();
            // this.profileForm.get('countryCode').markAsDirty();
            // this.profileForm.get('phone').markAsDirty();
            // this.profileForm.get('email').markAsDirty();
            // this.profileForm.get('version').markAsDirty();
            // return;
        }
    }

    openChangeEmailDialog() {
        if (this.userIdParam) {
            const dialogref = this.dialog.open(ChangeEmailComponent, {
                hasBackdrop: true,
                width: '700px',
                panelClass: 'task-detail-modal',
                data: {
                    alertTitle: 'Change User Email',
                    userId: this.userID
                }
            });
        } else {
            const dialogref = this.dialog.open(ChangeEmailComponent, {
                hasBackdrop: true,
                width: '700px',
                panelClass: 'task-detail-modal',
                data: {
                    alertTitle: 'Change Email',
                    email: this.profileForm.value.email,
                    registeredCountryCode: this.profileForm.value.countryCode,
                    registeredPhone: this.profileForm.value.phone
                }
            });
        }
    }

    isInputNumber(event) {
        const ch = String.fromCharCode(event.which);
        if (!(/[0-9]/.test(ch))) {
            event.preventDefault();
        }
    }

    handleFileInput(event) {
        if (event.target.files.length > 0) {
            let fileExtension = event.target.files[0].name.split('.').pop().toLowerCase();
            let allowedExtensions = ["jpg", "jpeg", "png"];
            let found = allowedExtensions.includes(fileExtension);
            if (!found) {
                this.isProfileImageInvalid = true;
                return false;
            }
            this.isProfileImageInvalid = false;

            this.store.dispatch(new LoaderShow());
            this.file = event.target.files[0];
            this.userProfileImage = event.target.files[0];
            this.profilePicName = this.file.name;
            const reader = new FileReader();
            reader.onload = (event: any) => {
                this.file = event.target.result;
                this.store.dispatch(new LoaderHide());
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    openChangePhoneDialog() {
        if (this.userIdParam) {
            const dialogref = this.dialog.open(ChangePhoneComponent, {
                hasBackdrop: true,
                width: '700px',
                panelClass: 'task-detail-modal',
                data: {
                    alertTitle: 'Change user phone number',
                    userId: this.userID,
                    phoneNumber: this.profileForm.value.phone,
                    countryCode: this.profileForm.value.countryCode
                }
            });
        } else {
            const dialogref = this.dialog.open(ChangePhoneComponent, {
                hasBackdrop: true,
                width: '700px',
                panelClass: 'task-detail-modal',
                data: {
                    alertTitle: 'Change Phone',
                    countryCode: this.profileForm.value.countryCode,
                    phoneNumber: this.profileForm.value.phone,
                    registeredEmail: this.profileForm.value.email
                }
            });


        }
    }

    cancelClicked() {
        this.location.back();
    }

    setDefaultPic() {
        this.file = "assets/images/default-profile-img.svg";
    }
}
